import _ from 'lodash'
import B_TV_TABS_CONFIG from './config'

class BusinessTvTabsClass {
    constructor() {
        this.DOM = {
            element: B_TV_TABS_CONFIG.element,
            triggers: Array.from( B_TV_TABS_CONFIG.triggers ),
            contents: Array.from( B_TV_TABS_CONFIG.contents )
        }

        this.DOM.element ? this.init() : null

        this.current = null
    }

    init() {
        this._initialTab()
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.triggers.forEach( ( trigger ) => { trigger.addEventListener( 'click', this._current.bind( this ) ) })
    }

    _initialTab() {
        this.current = this.DOM.triggers[0].getAttribute( 'data-tab' )
        this._active( this.current )
    }

    _current() {
        this.current = event.currentTarget.getAttribute( 'data-tab' )
        this._active( this.current )
    }

    _active( tab ) {
        this.DOM.triggers.forEach( ( trigger ) => { _.removeClass( trigger, 'is--active' )})
        this.DOM.contents.forEach( ( content ) => { _.removeClass( content, 'is--active' )})

        const activeTrigger = this.DOM.triggers.filter( trigger => trigger.getAttribute( 'data-tab' ) == tab )[0]
        const activeContent = this.DOM.contents.filter( content => content.getAttribute( 'data-tab' ) == tab )[0]
       _.addClass( activeTrigger, 'is--active' )
       _.addClass( activeContent, 'is--active' )
    }
}

const B_TV_TABS = new BusinessTvTabsClass()
export default B_TV_TABS